<template>
  <div id="default-layout" :class="{ 'desktop': isPc }">
    <!-- <router-view :key="$route.fullPath"></router-view> -->
    <olakkDesktop v-if="isOlakkDesktop"></olakkDesktop>
    <canadaView v-else-if="isCanada"></canadaView>
    <euView v-else-if="isEuropean"></euView>
    <router-view v-else></router-view>

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
    </router-view> -->
  </div>
</template>

<script>
import olakkDesktop from '../views/olakkDesktop.vue'
import { olaKKClubs } from '../configs/clubs'
import { setLicenseType } from '../configs/licenseType'
import { checkIpLegal } from '@/api/official'
import { getGps } from '@/utils/browserCheck.js'
import canadaView from '../views/canadaView.vue'
import euView from '../views/euView.vue'
import Store from '@/store.js'
export default {
  components: {
    olakkDesktop,
    canadaView,
    euView,
  },
  // 监听,当路由发生变化的时候执行
  data() {
    return {
      scroll: 0
    }
  },
  beforeRouteEnter(to, from, next) {
    // 判斷是否為手機及獲取經緯度
    getGps().then((res) => {
      const { lat, lon } = res
      const param = lat && lon ? { type: 1, gps_lat: lat, gps_lon: lon } : { type: 1 }
      checkIpLegal(param).then((res) => {
        setLicenseType(res)
        Store.dispatch('setDownloadLink', res);
        next();
      })
    });
  },
  computed: {
    inviteCode() {
      return this.$route.params.invitecode ? this.$route.params.invitecode.toLocaleLowerCase() : null
    },
    isOlakkDesktop() {
      const isDesktop = window.innerWidth > 768
      const isOlakk = olaKKClubs.includes(this.inviteCode)
      return isDesktop && isOlakk
    },
    isCanada() {
      const clubIds = ['388978']
      return clubIds.includes(this.inviteCode)
    },
    isEuropean() {
      const clubIds = ['384234', '383382', 'jonkyte']
      return clubIds.includes(this.inviteCode)
    },
    isPc() {
      return window.innerWidth > 768
    },
    isMobileDevice() {
      const ua = navigator.userAgent.toLowerCase()
      const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mac|/i.test(ua)
      return !!(isMobile && navigator.maxTouchPoints > 1)
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'events' || to.name === 'events-ppwc' || to.name === 'events-schedule' || to.name === 'festival' || to.name === 'festival-upcoming' || to.name === 'festival-past' || to.name === 'upcoming-activate-step1' || to.name === 'upcoming-activate-step2' || to.name === 'upcoming-activate-step3' || to.name === 'upcoming-activate-step4' || to.name === 'upcoming-activate-step5' || to.name === 'upcoming-activate-dec-step1') {
        this.$store.commit('changeTab', 1)
      } else if (to.name === 'blog' || to.name === 'blog-item') {
        this.$store.commit('changeTab', 2)
      } else {
        this.$store.commit('changeTab', 0)
      }

      if (to.name === 'item' && from.name === 'answer') {
        setTimeout(() => {
          document.querySelector('#default-layout').scrollTop = parseInt(
            this.$store.state.scroll
          )
        }, 0)
      } else {
        document.querySelector('#default-layout').scrollTop = 0
      }
    }
  }
}
</script>

<style lang="less">
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  position: relative;
  font-family: 'Noto Sans JP', "PingFang SC", Helvetica, "STHeiti STXihei", "Microsoft YaHei",
    Tohoma, Arial, sans-serif;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
}

#default-layout {
  width: 10rem;
  min-height: 100%;
  position: relative;
  // overflow-y: auto;
  // overflow-x: hidden;
  margin: 0 auto;
  background-color: #fff;
  color: #727272;

  &.desktop {
    width: 100%;
    height: 100%;
  }
}

@media only screen and (max-width: 700px) {

  html,
  body {
    background-color: #fff;
  }
}

@media only screen and (min-width: 800px) {
  body {
    font-size: 100% !important;
  }
}

#default-layout,
html,
body {
  // overflow:hidden;/* winphone8和android4+ */
  -webkit-overflow-scrolling: touch;
  /* ios5+ */
}

#default-layout:after {
  min-height: calc(100% + 1px);
}

p {
  margin: 0;
  padding: 0;
  word-wrap: break-word;
  font-size: 28px;
  line-height: 32px;
}

a {
  font-size: 28px;
  text-decoration: none !important;
}

.disnone {
  display: none;
}

.van-dialog {
  width: 288px;
}

.center {
  text-align: center;
}

//全局样式
.black_bg {
  background-color: #100e0f;
}

.green_bg {
  background-color: #289753;
}

.primary_title_color {
  color: #269853;
}

.primary_color {
  color: #289753;
}

.regular_title_color {
  color: #a6a6a6;
}

.regular_color {
  color: #727272;
}

.divider_color {
  position: relative;
  background-color: #e4e4e4;
  width: 100%;
  height: 26px;
}

//vant 的自定义样式
.van-tabs__line {
  width: 44px !important;
  height: 6px !important;
  border-radius: 0px !important;
}

.van-tabs--line .van-tabs__wrap {
  height: 44px !important;
}

.van-tab {
  line-height: 44px !important;
}

.line {
  border-top: none !important;
  border-bottom: 2px solid#c0c0c0 !important;
  // opacity: 0.4;
}

.line.green {
  border-top: none !important;
  border-bottom: 2px solid#2e7149 !important;
}

.van-dialog {
  width: 660px !important;
}
</style>
